import { SelectionModel } from '@angular/cdk/collections';
import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, OnInit } from '@angular/core';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { PermissionGroupModal, PermissionNode } from '@app/feature/super-admin/models/client';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';
import { TeamMember } from '../../models/TeamMember';
import { TeamService } from '../../services/team/team.service';

@Component({
  selector: 'app-team-invite',
  templateUrl: './team-invite.component.html',
  styleUrls: ['./team-invite.component.css']
})
export class TeamInviteComponent implements OnInit {

  treeControl = new NestedTreeControl<PermissionNode>(node => node.Nodes);
  dataSource = new MatTreeNestedDataSource<PermissionNode>();
  hasChild = (_: number, node: PermissionNode) => !!node.Nodes && node.Nodes.length > 0;
  checklistSelection = new SelectionModel<PermissionNode>(true);
  getLevel = (node: PermissionNode) => node.Level;

  PermissionGroupModal!: PermissionGroupModal;
  HasPermissionGroupName: boolean = true;
  PermissionGroupTitle: string;
  PermissionGroups: any[] = [];
  searchTerm: any;
  SearchPermissionGroups: any;
  IsEditCase: boolean;
  isOwner: boolean = false;
  InviteeMail: string = null
  constructor(private router: Router, private activatedRoute: ActivatedRoute, private teamService: TeamService, private loaderService: LoaderService,
    private notificationService: NotificationService, private errorhandlerService: ErrorhandlerService) { }
  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      if (params['user'] == 'owner')
        this.isOwner = true;
    });
    this.fn_getAllPermisionList(null);
  }

  fn_getAllPermisionList(userId) {
    this.IsEditCase = userId != null ? true : false;
    this.teamService.GetPermissionList(userId).subscribe((res: any) => {
      if (res.StatusCode == 200) {
        this.removeChecklistSelection();

        this.dataSource.data = Object.keys(res.Data.ResponseData.PermissionNode)
          .map(function (k) { return res.Data.ResponseData.PermissionNode[k] })[1];
        //Make the tree view expanded by defualt
        this.treeControl.dataNodes = this.dataSource.data;
        this.treeControl.expandAll();

        this.MakeDefualtPermissionChecked();
      }
    })
  }
  MakeDefualtPermissionChecked() {
    if (this.treeControl.dataNodes != undefined) {
      //check permission by defualt that we get from db
      var node = this.treeControl.dataNodes[0];
      //Get those desended nodes which are cheked by default
      const descendants = this.treeControl.getDescendants(node).filter(function (item) {
        return item.PermissionId != -1 && item.IsChecked == true;
      });

      this.checklistSelection.select(...descendants)

      // Force update for the parent
      descendants.forEach(child => this.checklistSelection.isSelected(child));
      this.checkAllParentsSelection(node);
    }
  }
  checkAllParentsSelection(node: PermissionNode): void {
    let parent: PermissionNode | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelection(parent);
      parent = this.getParentNode(parent);
    }
  }
  checkRootNodeSelection(node: PermissionNode): void {
    const nodeSelected = this.checklistSelection.isSelected(node);
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.length > 0 && descendants.every(child => {
      return this.checklistSelection.isSelected(child);
    });
    if (nodeSelected && !descAllSelected) {
      this.checklistSelection.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.checklistSelection.select(node);
    }
  }
  sendInvite() {
    let payload: TeamMember = {
      Email: this.InviteeMail,
      CompanyId: parseInt(localStorage.getItem('companyId')),
      Role: this.isOwner ? 'owner' : 'staff',
      Permission: this.checklistSelection.selected.filter(function (item) {
        return item.PermissionId != -1;
      }).map(ele => ele.PermissionId)
    }
    if (payload.Permission.length == 0 && payload.Role == 'staff') {
      this.notificationService.info('Please assign a permission.', 'Info')
      return;
    }
    this.loaderService.show();
    this.teamService.sendInvite(payload)
      .subscribe((res: any) => {
        if (res.StatusCode === 200) {
          this.notificationService.success('Invitation sent.', 'Success')
          this.InviteeMail = null;
          this.router.navigate(['/store/team']);
          this.loaderService.hide();
        } else
          this.notificationService.error(res.Message, 'Error');
        
          this.loaderService.hide();
      }, err => {
        this.loaderService.hide();
        this.notificationService.error(err.Message, 'Error');
        this.errorhandlerService.handleError(err);
      });
  }

  removeChecklistSelection() {
    if (this.treeControl.dataNodes != undefined) {
      //uncheck from root
      const descendants = this.treeControl.getDescendants(this.treeControl.dataNodes[0]);
      this.checklistSelection.deselect(...descendants);
    }
  }

  getParentNode(node: PermissionNode): PermissionNode | null {

    const currentLevel = this.getLevel(node);

    if (currentLevel < 1) {
      return null;
    }

    if (node.Nodes.length > 0) {
      const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

      for (let i = startIndex; i >= 0; i--) {
        const currentNode = this.treeControl.dataNodes[i];

        if (this.getLevel(currentNode) < currentLevel) {
          return currentNode;
        }
      }
    }
    return null;
  }
  /** Whether all the descendants of the node are selected. */
  descendantsAllSelected(node: PermissionNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.length > 0 && descendants.every(child => {
      return this.checklistSelection.isSelected(child);
    });
    return descAllSelected;
  }

  /** Whether part of the descendants are selected */
  descendantsPartiallySelected(node: PermissionNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some(child => this.checklistSelection.isSelected(child));
    return result && !this.descendantsAllSelected(node);
  }
  /** Toggle the to-do item selection. Select/deselect all the descendants node */
  todoItemSelectionToggle(node: PermissionNode): void {
    this.checklistSelection.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);

    // Force update for the parent
    descendants.forEach(child => this.checklistSelection.isSelected(child));
    this.checkAllParentsSelection(node);
  }
  /** Toggle a leaf to-do item selection. Check all the parents to see if they changed */
  todoLeafItemSelectionToggle(node: PermissionNode): void {
    this.checklistSelection.toggle(node);
    this.checkAllParentsSelection(node);
  }
}
